import React from 'react';

interface BacklinksIconProps extends React.SVGAttributes<SVGElement> {
  height?: number;
  className?: string;
}

export const BacklinksIcon: React.FC<BacklinksIconProps> = ({
  height = 24,
  className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      width={height}
      className={className}
      viewBox="0 0 32 32"
      stroke="currentColor"
      fill="none"
      {...props}
    >
      <path strokeWidth="2" d="M16,1a15,15 0 1,0 0.2,0z" />
      <path
        strokeWidth="1.5"
        d="m16,1v30m15-15H1M4.5,7a20,20 0 0,0 23,0 m0,18 a20,20 0 0,0-23,0M15,2a19,19 0 0,0 0,29 m2,0 a19,19 0 0,0 0-29"
      />
    </svg>
  );
};
